import React from 'react';

const LoginPage = ({ onLogin, authUrl }) => {
  const handleMicrosoftLogin = () => {
    // Redirect to Microsoft Entra authentication
    window.location.href = authUrl;
  };
  
  return (
    <div className="dashboard">
      <div className="alert alert-info" style={{ 
        borderRadius: '8px', 
        padding: '16px',
        backgroundColor: '#e3f2fd', 
        textAlign: 'center',
        marginBottom: '20px'
      }}>
        <h3 style={{ marginBottom: '10px' }}>Authentication Required</h3>
        <p>You need to sign in using Microsoft Entra ID to access this application.</p>
      </div>
      
      {/* Hero Section */}
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        marginTop: '40px', 
        textAlign: 'center',
        padding: '20px'
      }}>
        <h1 className="card-title" style={{ fontSize: '2rem', marginBottom: '20px' }}>
          Welcome to Kipu ICD Service
        </h1>
        <p style={{ fontSize: '18px', color: '#555', lineHeight: '1.6', marginBottom: '30px' }}>
          This service provides standardized ICD-10-CM diagnostic codes and DSM-V mental health codes for the Kipu EMR system.
          Access comprehensive coding resources to ensure accurate medical documentation and patient care.
        </p>
        
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '40px 0' }}>
          <button 
            className="btn btn-microsoft" 
            onClick={handleMicrosoftLogin}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 30px',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: '500',
              backgroundColor: '#0078d7',
              border: 'none',
              boxShadow: '0 2px 8px rgba(0, 120, 215, 0.3)',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            <i className="fab fa-microsoft" style={{ marginRight: '10px' }}></i>
            Sign in with Microsoft
          </button>
          
          <div style={{ marginTop: '20px' }}>
            <a href={authUrl} style={{ textDecoration: 'underline' }}>
              Click here if the button doesn't work
            </a>
          </div>
        </div>
      </div>
      
      {/* Features Section */}
      <div style={{ 
        backgroundColor: '#f7f9fb', 
        padding: '40px 0', 
        margin: '30px 0',
        borderTop: '1px solid #eaedf0',
        borderBottom: '1px solid #eaedf0'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 20px' }}>
          <h2 style={{ textAlign: 'center', color: '#2d3e50', marginBottom: '40px', fontSize: '1.6rem' }}>
            Key Features
          </h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '30px' 
          }}>
            <div className="info-box" style={{ textAlign: 'left', borderTop: '3px solid #0078d7' }}>
              <h3 style={{ fontSize: '1.2rem', color: '#2d3e50' }}>Standardized ICD-10-CM Codes</h3>
              <p style={{ color: '#555', lineHeight: '1.5' }}>
                Access the complete set of ICD-10-CM diagnostic codes for accurate medical documentation and billing.
              </p>
            </div>
            <div className="info-box" style={{ textAlign: 'left', borderTop: '3px solid #0078d7' }}>
              <h3 style={{ fontSize: '1.2rem', color: '#2d3e50' }}>DSM-V Integration</h3>
              <p style={{ color: '#555', lineHeight: '1.5' }}>
                Includes Diagnostic and Statistical Manual of Mental Disorders (DSM-V) codes for comprehensive mental health diagnosis and treatment planning.
              </p>
            </div>
            <div className="info-box" style={{ textAlign: 'left', borderTop: '3px solid #0078d7' }}>
              <h3 style={{ fontSize: '1.2rem', color: '#2d3e50' }}>API Integration</h3>
              <p style={{ color: '#555', lineHeight: '1.5' }}>
                Seamless integration with Kipu EMR and other systems through our robust API.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Technical Info Section */}
      <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
        <h2 style={{ textAlign: 'center', color: '#2d3e50', marginBottom: '30px', fontSize: '1.4rem' }}>
          Technical Information
        </h2>
        
        <div className="info-grid" style={{ 
          marginTop: '20px', 
          display: 'flex', 
          justifyContent: 'start',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div className="info-box" style={{ minWidth: '200px' }}>
            <h2 className="info-box-title">API VERSION</h2>
            <p>v1</p>
          </div>
          
          <div className="info-box" style={{ minWidth: '200px' }}>
            <h2 className="info-box-title">STATUS</h2>
            <p style={{ color: '#28a745' }}>
              <i className="fas fa-check-circle" style={{ marginRight: '5px' }}></i>
              Operational
            </p>
          </div>
        </div>
        
        <div className="code-block" style={{ 
          textAlign: 'left', 
          margin: '30px auto 0',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{ 
            padding: '8px 16px', 
            backgroundColor: '#1e2128', 
            borderTopLeftRadius: '4px', 
            borderTopRightRadius: '4px',
            borderBottom: '1px solid #444',
            color: '#abb2bf',
            fontSize: '12px'
          }}>
            API Response Example
          </div>
          <pre style={{ margin: 0, padding: '16px' }}>
{`// GET /codes?term=F32&limit=3

[
  {
    "id": 3152,
    "name": "F32.0",
    "long_description": "Major depressive disorder, single episode, mild",
    "valid_code": true,
    "info": "Clinical Information: A mood disorder having a clinical course involving one or more episodes of serious psychological depression...",
    "group": "ICD-10-CM"
  },
  {
    "id": 3153,
    "name": "F32.1",
    "long_description": "Major depressive disorder, single episode, moderate",
    "valid_code": true,
    "info": null,
    "group": "ICD-10-CM"
  },
  {
    "id": 3154,
    "name": "F32.2",
    "long_description": "Major depressive disorder, single episode, severe without psychotic features",
    "valid_code": true,
    "info": null,
    "group": "ICD-10-CM"
  }
]`}
          </pre>
        </div>
      </div>
      
      {/* Footer */}
      <div style={{ 
        borderTop: '1px solid #eaedf0', 
        padding: '20px', 
        textAlign: 'center',
        color: '#6c757d',
        fontSize: '14px',
        marginTop: '40px'
      }}>
        Kipu ICD Service © {new Date().getFullYear()} Kipu Health
      </div>
    </div>
  );
};

export default LoginPage; 
